import { TInventory } from "@components/types";
import { getImageObject, getSafeUrl, humanizeCurrency, sanityIoImageLoader } from '@core/utils';
import Image from "next/image";
import Link from "next/link";
import React from "react";

type Props = {
    product: TInventory;
    loading?: "lazy" | "eager"
};


export const AssetServiceCard: React.FC<Props> = ({ product, loading }) => {
    let servicedProduct = product?.product;

    return (
        <div key={product.id} className="bg-neutral-50 rounded-xl shrink-0 h-max w-40 overflow-hidden">
            <div className="flex justify-center h-40">
                <Link href={`/service/${product.id}/${getSafeUrl(servicedProduct?.name)}`} prefetch={false}>
                    <Image
                        loader={sanityIoImageLoader}
                        className="w-full h-full object-cover"
                        src={getImageObject(product?.product?.images)?.url}
                        alt={"Asset Group"}
                        width="150"
                        height="150"
                        loading={loading}
                    />
                </Link>
            </div>
            <div className="flex flex-col gap-1 overflow-hidden p-2 font-manrope">
                <div className="pb-1">
                    <div className="text-sm font-semibold line-clamp-1 text-neutral-900 text-ellipsis break-words line-clamp-2 md:line-clamp-none leading-tight">{servicedProduct?.name}</div>
                </div>
                {product?.price || servicedProduct?.mrp > 0 ?
                    <div className="text-sm font-semibold text-neutral-700 text-ellipsis line-clamp-1 md:line-clamp-none leading-tight">{humanizeCurrency(product?.price || servicedProduct?.mrp)}</div>
                    :
                    <div className="text-xs font-medium text-neutral-500">Not Specified</div>
                }
                <Link href={`/service/assetservice/${product.id}/${getSafeUrl(servicedProduct?.name)}`} prefetch={false}><div className="flex flex-row justify-center items-center md:text-sm text-xs font-semibold text-brand_indigo border border-solid border-brand_indigo rounded-sm py-0.5">View Details</div></Link>
            </div>
        </div>
    )
}